export default __webpack_public_path__ + "static/media/FHash4.5e9b488b.mp3";